import React from 'react';
export function Footer() {
  return <footer className="bg-pilates-dark text-white/70 py-10 px-4 text-center text-sm" data-id="element-95">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-96">
        <p data-id="element-97">
          © {new Date().getFullYear()} Pilates Prêt — Tous droits réservés.
        </p>
        <p className="text-xs text-white/55 max-w-2xl mx-auto leading-relaxed" data-id="element-98">
          Le contenu de cette page est à but informatif et éducatif. Il ne
          remplace pas une formation professionnelle certifiée. Consultez un
          professionnel de santé avant d'entreprendre toute nouvelle activité
          physique.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-2 text-xs text-white/60" data-id="element-99">
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-100">
            Conditions Générales
          </a>
          <span data-id="element-101">·</span>
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-102">
            Politique de Confidentialité
          </a>
          <span data-id="element-103">·</span>
          <a href="#" className="hover:text-pilates-cream transition-colors" data-id="element-104">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}